<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>                
        <v-row>   
            <v-col cols="9">
                <div class="text-left">
                    <p>Breakfast Burrito $25 + $2.09 Tax + $10 tip</p>
                    <img alt="Breakfast Burrito" class="uitk-image-media" src="/vegasjan/BreakfastBurrito.jpg" style="width: 17%; height: auto;">                
                    <p>CVS for supplies - water</p>
                </div>
                <div class="text-left">
                    <p>Cronut $9.99 + Ham Ficelle $18.99 + 2.43 Tax  Lunch and dinner was a lot of food</p>
                    <img alt="Cronut" class="uitk-image-media" src="/vegasjan/Cronut.jpg" style="width: 17%; height: auto;">                
                </div>                
                <div class="text-left">
                    <p>View from room at night</p>
                    <img alt="Night View" class="uitk-image-media" src="/vegasjan/NightView.jpg" style="width: 17%; height: auto;">                
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Fan at front door fixed today.</p>
                </div>
            </v-col> 
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Some gambling and drinking occurred among other things.</p>
                </div>  
                <div class="text-left">
                    <p>Stock market open most things down ... good day to buy.</p>
                </div>
            </v-col>               
        </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>